{
  "FILTER": {
    "TITLE": "Filtrar conversaciones",
    "SUBTITLE": "Añada sus filtros a continuación y pulse 'Aplicar filtros' para cortar el caos del chat.",
    "EDIT_CUSTOM_FILTER": "Editar carpeta",
    "CUSTOM_VIEWS_SUBTITLE": "Agregar o eliminar filtros y actualizar la carpeta.",
    "ADD_NEW_FILTER": "Añadir Filtro",
    "FILTER_DELETE_ERROR": "¡Vaya, parece que no podemos guardar nada! Por favor, añade al menos un filtro para guardarlo.",
    "SUBMIT_BUTTON_LABEL": "Aplicar filtros",
    "UPDATE_BUTTON_LABEL": "Actualizar carpeta",
    "CANCEL_BUTTON_LABEL": "Cancelar",
    "CLEAR_BUTTON_LABEL": "Limpiar filtros",
    "FOLDER_LABEL": "Nombre de la carpeta",
    "FOLDER_QUERY_LABEL": "Consulta de carpetas",
    "EMPTY_VALUE_ERROR": "El valor es requerido.",
    "TOOLTIP_LABEL": "Filtrar conversaciones",
    "QUERY_DROPDOWN_LABELS": {
      "AND": "Y",
      "OR": "O"
    },
    "INPUT_PLACEHOLDER": "Introducir valor",
    "OPERATOR_LABELS": {
      "present": "Presente",
      "not_present": "No presente",
      "present_with_answer": "Presente con respuesta",
      "present_without_answer": "Presente sin respuesta",
      "equal_to": "Igual a",
      "not_equal_to": "No igual a",
      "does_not_contain": "No contiene",
      "is_present": "Está presente",
      "is_not_present": "No está presente",
      "is_greater_than": "Es mayor que",
      "is_less_than": "Es menor que",
      "starts_with": "Empieza con",
      "equalTo": "Igual a",
      "notEqualTo": "No igual a",
      "contains": "Contiene",
      "doesNotContain": "No contiene",
      "isPresent": "Está presente",
      "isNotPresent": "No está presente",
      "isGreaterThan": "Es mayor que",
      "isLessThan": "Es menor que",
      "startsWith": "Empieza con",
      "is_greater_than_or_equal": "Es mayor o igual a",
      "is_less_than_or_equal": "Es menor o igual a",
      "newer_than_days": "Es más reciente que x días (inclusive)",
      "older_than_days": "Es más antiguo que x días (inclusive)",
      "isGreaterThanOrEqual": "Es mayor o igual a",
      "isLessThanOrEqual": "Es menor o igual a"
    },
    "ATTRIBUTE_LABELS": {
      "TRUE": "Verdadero",
      "FALSE": "Falso"
    },
    "ATTRIBUTES": {
      "STATUS": "Estado",
      "ASSIGNEE_NAME": "Nombre Asignado",
      "INBOX_NAME": "Nombre de la bandeja de entrada",
      "TEAM_NAME": "Nombre del equipo",
      "CONVERSATION_IDENTIFIER": "Identificador de conversacion",
      "CAMPAIGN_NAME": "Nombre de Campaña",
      "LABELS": "Etiquetas",
      "BROWSER_LANGUAGE": "Idioma del navegador",
      "PRIORITY": "Prioridad",
      "COUNTRY_NAME": "Nombre del país",
      "REFERER_LINK": "Enlace de referencia",
      "CUSTOM_ATTRIBUTE_LIST": "Lista",
      "CUSTOM_ATTRIBUTE_TEXT": "Texto",
      "CUSTOM_ATTRIBUTE_NUMBER": "Número",
      "CUSTOM_ATTRIBUTE_LINK": "Enlace",
      "CUSTOM_ATTRIBUTE_CHECKBOX": "Casilla",
      "CREATED_AT": "Creado el",
      "LAST_ACTIVITY": "Última actividad",
      "LAST_CUSTOMER_MESSAGE_AT": "Último mensaje del cliente",
      "PHONE_CALL": "Llamada telefónica",
      "RATING": "Valoración",
      "CSAT": "CSAT"
    },
    "ERRORS": {
      "VALUE_REQUIRED": "El valor es requerido",
      "ATTRIBUTE_KEY_REQUIRED": "Clave de atributo es requerida",
      "FILTER_OPERATOR_REQUIRED": "El operador de filtro es requerido",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "El valor debe ser entre 1 y 998",
      "VALUE_MUST_BE_BETWEEN_0_AND_998": "El valor debe estar entre 0 y 998"
    },
    "GROUPS": {
      "STANDARD_FILTERS": "Filtros estándar",
      "ADDITIONAL_FILTERS": "Filtros adicionales",
      "CUSTOM_ATTRIBUTES": "Atributos personalizados"
    },
    "CUSTOM_VIEWS": {
      "ADD": {
        "TITLE": "¿Desea guardar este filtro?",
        "LABEL": "Nombre de este filtro",
        "PLACEHOLDER": "Nombre su filtro para referirse más tarde.",
        "ERROR_MESSAGE": "El nombre es requerido.",
        "SAVE_BUTTON": "Guardar filtro",
        "CANCEL_BUTTON": "Cancelar",
        "API_FOLDERS": {
          "SUCCESS_MESSAGE": "Carpeta creada con éxito.",
          "ERROR_MESSAGE": "Error al crear la carpeta."
        },
        "API_SEGMENTS": {
          "SUCCESS_MESSAGE": "Segmento creado con éxito.",
          "ERROR_MESSAGE": "Error al crear segmento."
        }
      },
      "EDIT": {
        "EDIT_BUTTON": "Editar carpeta",
        "API_FOLDERS": {
          "ERROR_MESSAGE": "Error al actualizar la carpeta."
        }
      },
      "DELETE": {
        "DELETE_BUTTON": "Eliminar filtro",
        "MODAL": {
          "CONFIRM": {
            "TITLE": "Confirme eliminación",
            "MESSAGE": "¿Está seguro de que desea eliminar el filtro ",
            "YES": "Sí, eliminar",
            "NO": "No, mantenerlo"
          }
        },
        "API_FOLDERS": {
          "SUCCESS_MESSAGE": "Carpeta eliminada con éxito.",
          "ERROR_MESSAGE": "Error al eliminar carpeta."
        },
        "API_SEGMENTS": {
          "SUCCESS_MESSAGE": "Segmento eliminado con éxito.",
          "ERROR_MESSAGE": "Error al eliminar segmento."
        }
      }
    },
    "AI_PROMPT": "Filtro IA",
    "TEAMS_LABEL": "Compartir con",
    "PARENT_FOLDER_LABEL": "Carpeta principal",
    "NO_PARENT_FOLDER": "Sin carpeta principal",
    "BACKGROUND_COLOR_LABEL": "Color de fondo",
    "COLOR_LABEL": "Color",
    "SELECT_COLOR": "Seleccionar color",
    "CLEAR_SELECTION": "Borrar selección",
    "SORT_BY_LABEL": "Ordenar por",
    "PHONE_CALL_TYPES": {
      "INBOUND": "Entrante",
      "OUTBOUND": "Saliente",
      "MISSED": "Perdida",
      "UNHANDLED_MISSED": "Perdida sin gestionar"
    },
    "RATING_TYPES": {
      "UP": "Pulgar arriba",
      "DOWN": "Pulgar abajo"
    }
  }
}
